// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title-editable[data-v-f4b866e6] {\n\t-webkit-user-modify: read-write-plaintext-only;\n\toutline: none;\n\tcursor: text;\n\tbackground-color: var(--surface-3);\n\tbox-shadow: inset 0 0 0 1px var(--c-main);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
